module.exports = __webpack_public_path__ + "img/guide_arrow2.00c099ac.png";